import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight } from 'lodash';
import updatePreferences from './updatePreferences.graphql';
import withCurrentUser from './withCurrentUser';
import me from './withCurrentUser.graphql';
const withUserPreferences = options => flowRight(graphql(updatePreferences, {
    props: ({ mutate }) => ({
        updatePreferences: parameters => mutate({
            variables: {
                params: { ...parameters },
            },
        }),
    }),
    options: {
        refetchQueries: [{ query: me }],
    },
}), withCurrentUser(options), WrappedComponent => {
    var _a;
    const wrappedName = WrappedComponent.displayName || WrappedComponent.name;
    return _a = class extends React.PureComponent {
            render() {
                const { me, systemConfig } = this.props;
                const { preferences, accessList } = me || {};
                return (<WrappedComponent {...this.props} accessList={accessList} preferences={preferences || {}} systemConfig={systemConfig}/>);
            }
        },
        _a.displayName = `withUserPreferences(${wrappedName})`,
        _a.defaultProps = {
            currentUser: null,
            systemConfig: null,
        },
        _a;
});
export default withUserPreferences;
